// Website pages (sign-in): allow pinch-zoom — Frappe's viewport disables it (WCAG 1.4.4).
const meta = document.querySelector('meta[name="viewport"]');
if (meta && /user-scalable=no|maximum-scale/.test(meta.getAttribute("content") || "")) {
	meta.setAttribute("content", "width=device-width, initial-scale=1.0");
}
